import { render, staticRenderFns } from "./LearnIndex.vue?vue&type=template&id=37977787&scoped=true&slot-scope=%7B%20loading%20%7D"
import script from "./LearnIndex.vue?vue&type=script&lang=js"
export * from "./LearnIndex.vue?vue&type=script&lang=js"
import style0 from "./LearnIndex.vue?vue&type=style&index=0&id=37977787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37977787",
  null
  
)

export default component.exports